import {Link} from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const NavBar = ({auth, setAuth}) => {
    const [userName, setUserName] = useState(null);
    const navigator = useNavigate();

    useEffect(() => {
        const storedUsername = localStorage.getItem('userName');
        if (storedUsername) {
          setUserName(storedUsername);
        }
      }, [auth, userName]);
    
    const handleSignOut = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userName');
        localStorage.removeItem('userId');
        setUserName(null);
        setAuth(false);
        navigator('/login');  // Redirect to login page after signing out
    };

    
    return (
        <nav className='menu'>
            <Link to="/index">List</Link>
            <Link to="/new">New</Link>
            <Link to="/profile">Profile</Link>
            <div className="user">
                {userName ? (
                    <div className="user-info">
                    <span>Welcome, {userName}!</span>
                    <button className='sign-out' onClick={handleSignOut}>Sign Out</button>
                    </div>
                ) : (
                    <Link to="/login">login</Link>
                )}
            </div>
        </nav>
    );
}

export default NavBar;